/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, Input, Output, EventEmitter, OnInit } from '@angular/core';
import { UserService } from '../../services/user.service';
import { XrxControlBaseComponent } from '../controls/xrx-control-base.component';
import { OptionListOptions } from '../../services/workflow.service';

@Component({
  selector: 'xrx-pdf-convert',
  templateUrl: './xrx-pdf-convert.component.html',
  styleUrls: ['./xrx-pdf-convert.component.less'],
  providers: [
    { provide: XrxControlBaseComponent, useExisting: XrxPdfConvertComponent },
  ],
  standalone: false,
})
export class XrxPdfConvertComponent
  extends XrxControlBaseComponent
  implements OnInit
{
  @Input() list: OptionListOptions[] = [];
  @Input() selectedItem: any;
  @Input() isMfd: boolean;
  @Input() value: string; // pdfOptions
  @Input() value2: string; // language
  @Input() setting: any;

  @Output() change = new EventEmitter<any>();
  @Output() change2 = new EventEmitter<any>();
  @Output() validation = new EventEmitter<boolean>();
  @Output() selectedValueChange = new EventEmitter<OptionListOptions>();

  pdfOptions: PdfOptions = {
    format: 'image',
    compatibility: 'pdf16',
  };
  searchable = false;
  pdfA = false;
  documentInputLanguage = 'en';

  constructor(private userService: UserService) {
    super();
  }

  ngOnInit(): void {
    this.loadConfig();
  }

  languageSelected(event: any): void {
    this.documentInputLanguage = event.value;
    this.updatePdfConvertConfig();
  }

  searchToggle(event: boolean): void {
    this.searchable = event;
    this.updatePdfConvertConfig();
  }

  pdfAToggle(event: boolean): void {
    this.pdfA = event;
    this.updatePdfConvertConfig();
  }

  loadConfig(): void {
    if (this.value) {
      // update pdfOptions with saved value (saved workflow or navigating through workflow)
      this.pdfOptions = JSON.parse(this.value);
      this.searchable = this.pdfOptions.format == 'searchable' ? true : false;
      this.pdfA = this.pdfOptions.compatibility == 'pdfA1b' ? true : false;
    }
    if (this.value2) {
      this.documentInputLanguage = this.value2;
    } else {
      const userLang = this.userService?.user?.language || 'en-us';

      if (userLang == 'en-us' || userLang == 'pt-br') {
        this.documentInputLanguage = userLang.substring(0, 2);
      } else {
        this.documentInputLanguage = userLang;
      }
      this.value2 = this.documentInputLanguage;
    }

    // set selected document language
    this.selectedItem = this.setValue(this.documentInputLanguage, this.list);
  }

  setValue(newValue: string, optionList: any[]): any {
    if (!optionList) {
      return null;
    }

    let valueToSet = null;
    valueToSet = optionList.find((option) => option.value === newValue);

    return valueToSet;
  }

  updatePdfConvertConfig(): void {
    this.pdfOptions.format = this.searchable ? 'searchable' : 'image';
    this.pdfOptions.compatibility = this.pdfA ? 'pdfA1b' : 'pdf16';
    this.value = JSON.stringify(this.pdfOptions);
    this.change.emit(this.value);

    if (this.searchable && this.selectedItem) {
      this.value2 = this.documentInputLanguage;
      this.change2.emit(this.value2);
    }

    this.validation.emit(this.searchable && !this.selectedItem ? false : true);
  }

  validate() {
    // make sure that this.value isn't empty when navigating to the next step
    this.updatePdfConvertConfig();
  }
}
interface PdfOptions {
  format: string;
  compatibility: string;
}
